import { Form } from "react-bootstrap";

export const SPANISH_PROVINCES = [
  "Álava",
  "Albacete",
  "Alicante",
  "Almería",
  "Asturias",
  "Ávila",
  "Badajoz",
  "Barcelona",
  "Bizkaia",
  "Burgos",
  "Cáceres",
  "Cádiz",
  "Cantabria",
  "Castellón",
  "Ciudad Real",
  "Córdoba",
  "Cuenca",
  "Gipuzkoa",
  "Girona",
  "Granada",
  "Guadalajara",
  "Huelva",
  "Huesca",
  "Illes Balears",
  "Jaén",
  "A Coruña",
  "La Rioja",
  "Las Palmas",
  "León",
  "Lleida",
  "Lugo",
  "Madrid",
  "Málaga",
  "Murcia",
  "Navarra",
  "Ourense",
  "Palencia",
  "Pontevedra",
  "Salamanca",
  "Santa Cruz de Tenerife",
  "Segovia",
  "Sevilla",
  "Soria",
  "Tarragona",
  "Teruel",
  "Toledo",
  "Valencia",
  "Valladolid",
  "Zamora",
  "Zaragoza"
];

function ProvinceSelect({ id, value, onChange, ...props }) {
  const hasLegacyValue = value && !SPANISH_PROVINCES.includes(value);

  return (
    <Form.Select id={id} value={value || ""} onChange={onChange} autoComplete="address-level1" {...props}>
      <option value="">Selecciona una provincia</option>
      {hasLegacyValue && <option value={value}>{value} (ubicación actual)</option>}
      {SPANISH_PROVINCES.map(province => <option value={province} key={province}>{province}</option>)}
    </Form.Select>
  );
}

export default ProvinceSelect;
